exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Info__root,\n.DS__Info__security,\n.DS__Info__more {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n  .DS__Info__root {\n  display: flex;\n  flex-direction: column;\n  padding-top: 24px;\n  margin-bottom: 24px;\n}\n\n  @media (max-width: 767px) {.DS__Info__root {\n    flex-direction: column-reverse;\n    margin-bottom: 40px\n}\n  }\n\n.DS__Info__security {\n  display: flex;\n  align-items: center;\n  margin-bottom: 21px;\n}\n\n.DS__Info__security p:last-child {\n    margin-left: 8px;\n  }\n\n@media (max-width: 767px) {\n\n.DS__Info__security {\n    margin-bottom: 0\n}\n  }\n\n@media (max-width: 767px) {\n\n.DS__Info__agreement {\n    margin-bottom: 20px\n}\n  }\n\n.DS__Info__more {\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  outline: none;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__Info__root",
	"security": "DS__Info__security",
	"more": "DS__Info__more",
	"agreement": "DS__Info__agreement"
};